import { render, staticRenderFns } from "./gardenfirst.vue?vue&type=template&id=b42881ea&scoped=true"
import script from "./gardenfirst.vue?vue&type=script&lang=js"
export * from "./gardenfirst.vue?vue&type=script&lang=js"
import style0 from "./gardenfirst.vue?vue&type=style&index=0&id=b42881ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42881ea",
  null
  
)

export default component.exports